/* tslint:disable */
/* eslint-disable */
/**
 * Y-sports-Core API
 * API for managing Y-sports related stuff
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Team } from './Team';
import {
    TeamFromJSON,
    TeamFromJSONTyped,
    TeamToJSON,
} from './Team';
import type { Tournament } from './Tournament';
import {
    TournamentFromJSON,
    TournamentFromJSONTyped,
    TournamentToJSON,
} from './Tournament';

/**
 * 
 * @export
 * @interface UserTeams
 */
export interface UserTeams {
    /**
     * 
     * @type {Tournament}
     * @memberof UserTeams
     */
    tournament?: Tournament;
    /**
     * 
     * @type {Array<Team>}
     * @memberof UserTeams
     */
    teams?: Array<Team>;
}

/**
 * Check if a given object implements the UserTeams interface.
 */
export function instanceOfUserTeams(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UserTeamsFromJSON(json: any): UserTeams {
    return UserTeamsFromJSONTyped(json, false);
}

export function UserTeamsFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserTeams {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'tournament': !exists(json, 'tournament') ? undefined : TournamentFromJSON(json['tournament']),
        'teams': !exists(json, 'teams') ? undefined : ((json['teams'] as Array<any>).map(TeamFromJSON)),
    };
}

export function UserTeamsToJSON(value?: UserTeams | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'tournament': TournamentToJSON(value.tournament),
        'teams': value.teams === undefined ? undefined : ((value.teams as Array<any>).map(TeamToJSON)),
    };
}

